<template>
  <div class="container">
    <img class="top-img" src="https://777-wx-res.oss-cn-beijing.aliyuncs.com/word_test/title_bank.png"/>
    <div class="list-container">
      <div class="txt-title">排行榜</div>
      <div class="self-rank">
        <div class="rank-num">{{selfrank.rank}}.</div>
        <img class="touxiang" src="https://777-wx-res.oss-cn-beijing.aliyuncs.com/word_test/cpsj_touxiang@2x.png">
        <div class="user-name">{{selfrank.user_name}}（自己）</div>
        <div class="self-score">{{selfrank.score}}分</div>
      </div>
      <div class="scollview-rank" style="overflow-y: auto" v-if="rankList">
        <!-- 列表 -->
        <div class="list-rank" v-for="(item,index) in rankList" >
          <div class="rank-num" v-if="item.sort>3">{{item.rank}}.</div>
          <img class="img-num" v-else-if="item.sort ===1" src="https://777-wx-res.oss-cn-beijing.aliyuncs.com/word_test/bd_pm_1@2x.png" alt="">
          <img class="img-num" v-else-if="item.sort ===2" src="https://777-wx-res.oss-cn-beijing.aliyuncs.com/word_test/bd_pm_2@2x.png" alt="">
          <img class="img-num" v-else-if="item.sort ===3" src="https://777-wx-res.oss-cn-beijing.aliyuncs.com/word_test/bd_pm_3@2x.png" alt="">
          <img class="touxiang" src="https://777-wx-res.oss-cn-beijing.aliyuncs.com/word_test/cpsj_touxiang@2x.png" alt="">
          <div class="user-name">{{item.user_name||'[暂无该学生]'}}</div>
          <div class="self-score">{{item.score}}分</div>
        </div>
      </div>
    </div>
    <div class="back_btn" @click="backRoute">
      <img src="https://777-wx-res.oss-cn-beijing.aliyuncs.com/2023_06_back.png" alt="">
    </div>
  </div>
</template>
<style lang="less" scoped>
.back_btn{
  position: fixed;
  left: 3rem;
  bottom: 2rem;
}
.container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  background-size: 100% 100%;
  background-image: url("https://777-wx-res.oss-cn-beijing.aliyuncs.com/word_test/bg_cp.png");
  height: 100%;
  width: 100%;
}

.top-img {
  width: 460px;
  margin-top: 40px;
}

.list-container {
  width: 460px;
  height:100%;
  background-repeat: no-repeat;
  background-size: 460px 100%;
  background-image: url("https://777-wx-res.oss-cn-beijing.aliyuncs.com/word_test/bd_biao@2x.png");
  margin-top: 22px;
  margin-bottom: 44px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.txt-title {
  height: 58px;
  font-size: 27px;
  font-weight: 600;
  color: #FFFFFF;
  line-height: 50px;
  text-align: center;
}

/* 自己的排名 */
.self-rank {
  width: 92%;
  height: 50px;
  background: #FFF0C5;
  border-radius: 6px;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 30px;
  margin-bottom: 25px;
}

.rank-num {
  width: 42px;
  height: 40px;
  font-size: 28px;
  color: #442A03;
  line-height: 40px;
  text-align: center;
  margin-left: 18px;
}

.touxiang {
  width: 50px;
  height: 50px;
  margin-left: 16px;
}

.user-name {
  width: 280px;
  height: 40px;
  font-size: 20px;
  color: #424242;
  line-height: 40px;
  text-align: left;
  margin-left: 24px;
}

.self-score {
  width: 164px;
  height: 54px;
  background: linear-gradient(180deg, #FFD540 0%, #FFAB1E 100%);
  border-radius: 16px;
  font-size: 28px;
  color: #352205;
  line-height: 54px;
  text-align: center;
  margin-right: 18px;
}

.scollview-rank{
  width: 92%;
  height: 75%;
}

.list-rank{
  width: 100%;
  height: 50px;
  background: #ECFFE2;
  border-radius: 6px;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 8px;
}

.img-num{
  width: 44px;
  height: 44px;
  margin-left: 10px;
}

</style>
<script>
import { mapState, mapMutations } from 'vuex'
import {test_online_ranking } from '../../services'

export default {
  name: 'word_competition_ranking',
  components: {},
  data () {
    return {
      imageurl: 'https://777-wx-res.oss-cn-beijing.aliyuncs.com/',
      rankList:[] ,//排行列表
      selfrank:{}, //自己的排名信息
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo
    })
  },
  created () {
    this.id = this.$route.query.id
    test_online_ranking({
      id: this.id,
    }).then((res) => {
      this.selfrank=res.data.self;
      this.rankList=res.data.ranking;
    })
  },
  methods:{
    backRoute:function () {
      this.$router.push({
        path: '/word_competition',
      })
    }
  },
}
</script>
